export { default } from './PasswordReset.data';
